import { useMessage } from '@/composables/useMessage'
import { StatusCode } from '@/enums/httpEnum'
import { MessageMode } from './types'
import { useGlobalI18n } from '@/composables/useI18n'
import { useUserStoreWithOut } from '@/store-pinia/modules/user'
const { createMessage, createErrorModal } = useMessage()

export function checkException(status: number, message: string, msgMode: MessageMode) {
  let errMsg = ''
  const { t } = useGlobalI18n()
  const userStore = useUserStoreWithOut()
  switch (status) {
    case StatusCode.UNAUTHORIZED_401:
      errMsg = t('用户登录已过期，请重新登录')
      userStore.setToken(undefined)
      userStore.logout(true)
      break
    case StatusCode.FORBIDDEN_403:
      errMsg = t('资源禁止访问')
      break
    case StatusCode.NOT_FOUND_404:
      errMsg = t('资源未找到')
      break
    case StatusCode.METHOD_NOT_ALLOWED_405:
      errMsg = t('请求方法不被允许')
      break
    case StatusCode.REQUEST_TIMEOUT_408:
      errMsg = t('请求超时')
      break
    case StatusCode.INTERNAL_SERVER_ERROR_500:
      errMsg = t('服务器内部发生错误')
      break
    case StatusCode.BAD_GATEWAY_502:
      errMsg = t('网关代理发生错误')
      break
    case StatusCode.SERVICE_UNAVAILABLE_503:
      errMsg = t('服务不可用')
      break
    case StatusCode.GATEWAY_TIMEOUT_504:
      errMsg = t('系统当前繁忙，请稍后重试！')
      break
    default:
      errMsg = message
  }

  if (errMsg) {
    if (msgMode === 'modal') {
      return createErrorModal({ content: errMsg })
    } else if (msgMode === 'message') {
      return createMessage.error({ content: errMsg })
    }
  }
}
